import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("di_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Global 401 handler: clear stale auth and bounce to /login (except during the login call itself).
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && !url.includes("/auth/login")) {
      localStorage.removeItem("di_token");
      localStorage.removeItem("di_user");
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
        window.location.replace("/login");
      }
    }
    return Promise.reject(err);
  }
);

export const setAuth = (token, user) => {
  localStorage.setItem("di_token", token);
  localStorage.setItem("di_user", JSON.stringify(user));
};
export const clearAuth = () => {
  localStorage.removeItem("di_token");
  localStorage.removeItem("di_user");
};
export const getUser = () => {
  try { return JSON.parse(localStorage.getItem("di_user")); } catch { return null; }
};
export const getToken = () => localStorage.getItem("di_token");
